import React from 'react'
import './Sidebar.scss'
export const Sidebar = ({isOpen,toggleSidebar}) => {
    return (
        <div className={`sidebar ${ isOpen ? 'show-sidebar' :'' }` }>
            <button className="nav-btn" onClick={ toggleSidebar }></button>
            <div className="side-container">
           
            </div>
        </div>

        
    )
}
